import { IExperiment } from '../../api/experiments';
import { checkExperiment } from '../isAbExperiment';

export function isNpsEnabled(experiments: IExperiment[]): boolean {
  return checkExperiment(experiments, 'nps', 1);
}
